module.exports = __webpack_public_path__ + "static/img/19.54970a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/19.png
// module id = LjY8
// module chunks = 0